import { render, staticRenderFns } from "./aguardandoUpload.vue?vue&type=template&id=bddf65a4&scoped=true"
import script from "./aguardandoUpload.vue?vue&type=script&lang=js"
export * from "./aguardandoUpload.vue?vue&type=script&lang=js"
import style0 from "./aguardandoUpload.vue?vue&type=style&index=0&id=bddf65a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf65a4",
  null
  
)

export default component.exports